import React from "react";
import PropTypes from "prop-types";

import styles from "./TwoSections.module.scss";

import { Row, Column } from "gatsby-theme-carbon";

function TwoSection(props) {
  const { title, children } = props;
  console.log(`#${title.toLowerCase().replace(/ /g, "-")}`);
  return (
    <Row>
      <Column colLg={4} colMd={3} colSm={4} className={styles.title}>
        <div id={`${title.toLowerCase().replace(/ /g, "-")}`}>{title}</div>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} className={styles.rightSide}>
        {children}
      </Column>
    </Row>
  );
}

TwoSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default TwoSection;
